import { render, staticRenderFns } from "./BusinessPlan.vue?vue&type=template&id=a7e5457a&"
import script from "./BusinessPlan.vue?vue&type=script&lang=js&"
export * from "./BusinessPlan.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports